// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__frame___O3bXj {
  border: 0;
  width: 100vw;
  height: 100vh;
  display: block;
}

.styles__imageContainer___c5u8q {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1b1b1b;
  margin: 0;
}

.styles__image___Gb1S9 {
  max-width: 100vw;
  max-height: 100vh;
  object-fit: contain;
  display: block;
}

.styles__message___tehZ5 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
  color: #2a2926;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/FileViewer/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,wFAAwF;EACxF,cAAc;EACd,eAAe;AACjB","sourcesContent":[".frame {\n  border: 0;\n  width: 100vw;\n  height: 100vh;\n  display: block;\n}\n\n.imageContainer {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #1b1b1b;\n  margin: 0;\n}\n\n.image {\n  max-width: 100vw;\n  max-height: 100vh;\n  object-fit: contain;\n  display: block;\n}\n\n.message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n  color: #2a2926;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `styles__frame___O3bXj`,
	"imageContainer": `styles__imageContainer___c5u8q`,
	"image": `styles__image___Gb1S9`,
	"message": `styles__message___tehZ5`
};
export default ___CSS_LOADER_EXPORT___;
